module.exports = __webpack_public_path__ + "static/media/no-data.240f383f.png";